import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login-component.component';
import { pimsRoutes } from './components/pims/pims.routes';
import { productQueueRoutes } from './components/product-queue/product-queue.routes';
import { Roles } from './enums/roles.enum';
import { AuthKeycloakGuard } from './guards/keycloak-auth/keycloak-auth-guard';
import { platformGuard } from './guards/platform/platform-guard';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';

export const routes: Routes = [
    { path: '', redirectTo: 'web', pathMatch: 'full' },
    {
        path: 'web',
        canActivate: [platformGuard, AuthKeycloakGuard],
        data: { device: 'web', allowedRoles: [Roles.All] },
        component: LoginComponent,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                canActivate: [AuthKeycloakGuard],
                data: { allowedRoles: [Roles.All] },
                loadComponent: () =>
                    import('./components/dashboard/dashboard.component').then((m) => m.DashboardComponent),
            },
            {
                path: 'product-categories',
                canActivate: [AuthKeycloakGuard],
                data: { allowedRoles: [Roles.NATIONAL_MANAGER_MARKETING] },
                loadComponent: () =>
                    import('./components/product-categories/product-categories.component').then(
                        (m) => m.ProductCategoriesComponent,
                    ),
            },
            {
                path: 'pims',
                canActivate: [AuthKeycloakGuard],
                data: { allowedRoles: [Roles.DISTRICT_PE_MANAGER] },
                children: pimsRoutes,
            },
            {
                path: 'product-queue',
                canActivate: [AuthKeycloakGuard],
                data: {
                    allowedRoles: [
                        Roles.BLOCK_MANAGER_MARKETING,
                        Roles.DISTRICT_MANAGER_MARKETING,
                        Roles.STATE_MANAGER_MARKETING,
                    ],
                },
                children: productQueueRoutes,
            },
            {
                path: 'unauthorized-access',
                loadComponent: () =>
                    import('./shared/unauthorized-access/unauthorized-access.component').then(
                        (m) => m.UnauthorizedAccessComponent,
                    ),
            },
        ],
    },

    {
        path: 'mobile',
        canActivate: [platformGuard, AuthKeycloakGuard],
        data: {
            device: 'mobile',
            allowedRoles: [
                Roles.SHG_BOOKKEEPER,
                Roles.VO_BOOKKEEPER,
                Roles.CLF_BOOKKEEPER,
                Roles.UDYOG_MITRA,
                Roles.BCF,
                Roles.BCIB,
                Roles.BCNF,
            ],
        },
        loadChildren: () => import('./components/mobile/mobile.routes').then((m) => m.mobileRoutes),
    },

    { path: '**', component: PageNotFoundComponent },
];
